import { render, staticRenderFns } from "./table.vue?vue&type=template&id=31653bb9"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31653bb9')) {
      api.createRecord('31653bb9', component.options)
    } else {
      api.reload('31653bb9', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=31653bb9", function () {
      api.rerender('31653bb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/queue_manage/form/table.vue"
export default component.exports